import { defaultAxiosInstance } from "./defaultInstance";

export const fetchMonthlyRevenue = async (yearMonth) => {
  const response = await defaultAxiosInstance.get("/admin/revenue/monthly", {
    params: { yearMonth },
  });
  return response.data;
};
